/* global BlankWallWidget */
import { useEffect } from 'react'
import Grid from '@mui/material/Grid';
import "./ProductListing.css";

const ProductListing = () => {

    useEffect(() => {
        // Load the remote script
        const script = document.createElement('script');
        script.src = 'https://dfv2bs0cn166o.cloudfront.net/script.min.js';
        script.async = true;
        document.body.appendChild(script);

        // Call a function from the remote script once it's loaded
        script.onload = () => {
            BlankWallWidget.init(
                {
                    ar_container_element_selector: "#blankwall-container",
                    ar_image_element_selector: ".ar_image_element_class",
                    ar_dimensions_element_selector: ".ar_dimensions_element_class",
                },
                {
                    buttonText: "View in AR",
                    backgroundColor: "black",
                    fontWeight: "500",
                    borderColor: "black",
                    borderRadius: "6px",
                    color: "white",
                    padding: "10px 20px",
                },
            );
            console.log("Blankwall Widget loaded")
        };

        return () => {
            // Clean up by removing the script from the DOM
            document.body.removeChild(script);
        };
    }, []);

  return (
    <div className="mac-window">
        <div className="mac-header">
            <div className="ui-menu-circle ui-menu-red"></div>
            <div className="ui-menu-circle ui-menu-yellow"></div>
            <div className="ui-menu-circle ui-menu-green"></div>
        </div>
        <div className="mac-content">
            <Grid container className='bg-primary' sx={{ padding: {xs: '0rem', md: '3rem'}}}>
                <Grid item xs={12} md={8} sx={{ paddingRight: { xs: '1rem', md: '1rem' }, alignItems: 'end', display:"flex"}}>
                    <img style={{ width: 'auto', maxWidth: '100%', maxHeight: '700px', margin: '0 auto'}} src='coupdevent.jpg' alt='automagically' />
                </Grid>
                <Grid item xs={12} md={4} sx={{ alignSelf: 'top', paddingLeft: { xs: 0, }}}>
                    <h3 style={{ fontSize: '1rem', fontWeight: '600' }}>
                        YOUR STORE
                    </h3>          
                    <h1 style={{ fontSize: '2rem'}}>
                        Coup De Vent
                    </h1>
                    <div className='product-listing-info'>
                        <h2 style={{ fontSize: '1rem', fontWeight: '300'}}>
                            Claude Monet
                        </h2>
                        <p style={{  paddingTop: '1rem', paddingBottom: '1rem'}}>
                            1881<br/>
                            Oil on Canvas
                        </p>
                    </div>

                    <h3 style={{ fontSize: '0.7rem', padding:'0'}}>
                        Size
                    </h3>
                    <button style={{ margin: '0', fontSize: '0.8rem', minHeight: '30px', backgroundColor:'transparent', color: 'black', borderRadius: '14px' }} className='hero-button'>
                        100 x 75 cm
                    </button>
                    <h1 className='foreground-highlight' style={{ fontSize: '1.2rem' }}>
                    {'\u2193'} Try Blankwall<br/>
                    </h1>

                    <div id='blankwall-container' >
                        <img className='ar_image_element_class' src='blankwalldemo.myshopify.com/cdn/shop/files/coupdevent.jpg?v=1709465711' alt='water-lilies' style={{display: 'none'}} />
                        <div className='ar_dimensions_element_class' style={{display: 'none'}}>100x75 cm</div>
                    </div>
                    <h3 style={{ fontSize: '0.7rem', padding:'0', paddingTop: '1rem'}}>
                        Quantity
                    </h3>
                    <button style={{ backgroundColor: 'transparent', paddingLeft: '1rem', paddingRight: '1rem', fontSize: '1.5rem', minHeight: '50px', minWidth: '150px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <span>{'\u2212'}</span>
                        <span>1</span>
                        <span>{'\u002B'}</span>
                    </button>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ProductListing